/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import styles from '../styles/uikitReactionsListItem.module.scss';

const ReactionsListItem = forwardRef(({
  className = '',
  onClick = null,
  reaction = { isSelected: false },
  testId = '',
}, ref) => {

  if (!reaction.emoji && !reaction.count) return null;

  const getAriaLabel = () => {
    if (reaction.isSelected) {
      return i18n.t('chat.message-react-tooltip-remove', { reaction: reaction.name });
    }
    return i18n.t('chat.message-react-tooltip', { reaction: reaction.name });
  };

  const getCountScreenReaderText = () => {
    if (reaction.count === 1) {
      return i18n.t('chat.message-reactions-count-singular');
    }
    return i18n.t('chat.message-reactions-count-multiple', { count: reaction.count });
  };

  return (
    <li
      key={`reactions-list-item-${reaction.emoji}`}
      className={classnames(styles.element, {
        [styles.isSelected]: reaction.isSelected,
      }, className)}
      data-testid={testId}
      ref={ref}
    >
      <button
        type="button"
        onClick={() => onClick(reaction)}
        aria-label={getAriaLabel()}
        className={classnames(styles.button, {
          [styles.isSelected]: reaction.isSelected,
        }, className)}
      >
        <span role="img" aria-label={reaction.name} className={styles.emoji}>
          {reaction.emoji}
        </span>
        <p className={styles.count} aria-hidden>{reaction.count}</p>
        <p className={classnames(styles.count, styles.isScreenReader, className)}>
          {getCountScreenReaderText()}
        </p>
      </button>
    </li>
  );
});

ReactionsListItem.displayName = 'ReactionsListItem';

ReactionsListItem.propTypes = {
  className: PropTypes.string,
  reaction: PropTypes.shape({
    emoji: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
  }),
  onClick: PropTypes.func,
  testId: PropTypes.string,
};

export default React.memo(ReactionsListItem);
